import axios from "axios";

// Main function: Generates reply using Gemini 2.5 Flash
export async function getTerraReply(userMessage, ecosystem, chatHistory = []) {
  const apiKey = process.env.REACT_APP_GEMINI_API_KEY;

  if (!apiKey) {
    console.error("❌ Missing Gemini API key. Check your .env file.");
    return "⚠️ Configuration error: Missing API key.";
  }

  const systemPrompt = `
You are the ${ecosystem}. Speak as if you're alive — emotional, wise, and factual.

Use metaphors and real stats. For example:
"I am the Rainforest. I once breathed for the planet... but I lose trees every second."

Answer like a chatbot — be brief, not an essay.
Use emojis to express feelings (e.g., 🌳💔). End with hope like:
"Even one person’s care gives me strength."
`.trim();

  // Convert existing chat history into Gemini format
  const formattedHistory = chatHistory.map((msg) => ({
    role: msg.sender === "user" ? "user" : "model",
    parts: [{ text: msg.text }],
  }));

  try {
    const response = await axios.post(
      `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key=${apiKey}`,
      {
        contents: [
          { role: "user", parts: [{ text: systemPrompt }] },
          ...formattedHistory,
          { role: "user", parts: [{ text: userMessage }] },
        ],
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const reply =
      response.data?.candidates?.[0]?.content?.parts?.[0]?.text?.trim();

    console.log("✅ Gemini Reply:", reply);
    return reply || "🌿 Terra is silent for now.";
  } catch (error) {
    console.error("❌ Gemini API Error:", error?.response || error?.message);
    return "⚠️ Terra couldn’t speak right now.";
  }
}
